import React from 'react'
import image1 from '../../Assests/Image/SocialMedia/Fb.png'
import image2 from '../../Assests/Image/SocialMedia/Insta.png'
import image3 from '../../Assests/Image/SocialMedia/Twitter.png'
import image4 from '../../Assests/Image/SocialMedia/Link.png'
import image5 from '../../Assests/Image/SocialMedia/Google.png'
import classes from './Footer.module.css'

const Footer = ()=>{
    return(
        <div className={classes.Container}>

            <div className={classes.subContainer}>
                <div className={classes.content}>
              <ul>
                  <li>
                    <a>About Us</a>  
                  </li>
                  <li>
                    <a>Rewards Point</a>  
                  </li>
                  <li>
                    <a>Privacy Policy</a>  
                  </li>
                  <li>
                    <a>Terms</a>  
                  </li>
                  <li>
                    <a>Careers</a>  
                  </li>
              </ul>
              </div>
              <div  className={classes.content}>
              <ul>
                  <li>
                    <a>Cancellation and Refund Policy</a>  
                  </li>
                  <li>
                    <a>Publisher Agreement</a>  
                  </li>
                  <li>
                    <a>Sitemap</a>  
                  </li>
                  <li>
                    <a>Contact Info</a>  
                  </li>
              </ul>
              </div>
              </div>
              <div className={classes.subContainer2}>
                <div style={{'display':'flex','justifyContent':'start'}}> <p className={classes.Download}>Download the App </p><img className={ classes.playstore} src="https://test-server.glossaread.com/img/rewamp/playstore-icon.png" height="40" width="40" /></div>
                <a className={classes.links}> Signup for newsletter</a>
                <p className={classes.followOn}>Follow us on</p>
                <div class="social">
        <a href="#"><img className={classes.socialImage} src={image1}/></a>
        <a href="#"><img  className={classes.socialImage}src={image2}/></a>
        <a href="#"><img  className={classes.socialImage}src={image3}/></a> 
        <a href="#"><img  className={classes.socialImage}src={image4}/></a> 
        <a href="#"><img  className={classes.socialImage}src={image5}/></a> 
        </div>  
              
                <p className={classes.copyright}>Copyright © 2019 Glossread Technologies Pvt .</p>
              </div>
        </div>
    )
}
export default Footer